/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PatientTreatmentQueuePatientIdHasQueuedGet$Params {
  patientId: string;
}

export function patientTreatmentQueuePatientIdHasQueuedGet(http: HttpClient, rootUrl: string, params: PatientTreatmentQueuePatientIdHasQueuedGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, patientTreatmentQueuePatientIdHasQueuedGet.PATH, 'get');
  if (params) {
    rb.path('patientId', params.patientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as PracticeStrictHttpResponse<boolean>;
    })
  );
}

patientTreatmentQueuePatientIdHasQueuedGet.PATH = '/PatientTreatmentQueue/{patientId}/HasQueued';
